import {
  EnrichmentAuthType,
  ExternalProviderError,
  ExternalProviderType,
} from 'crono-fe-common/types/externalEnrichmentProviders';

import Hunter from 'crono-fe-common/icons/Hunter.png';
import Prospeo from 'crono-fe-common/icons/Prospeo.png';
import Apollo from 'crono-fe-common/icons/Apollo.png';
import Datagma from 'crono-fe-common/icons/Datagma.png';
import RocketReach from 'crono-fe-common/icons/RocketReach.png';
import Findymail from 'crono-fe-common/icons/FindyMail.png';
import ContactOut from 'crono-fe-common/icons/ContactOut.png';
import Cleon1 from 'crono-fe-common/icons/Cleon1.png';
import IcyPeas from 'crono-fe-common/icons/IcyPeas.png';
import Forager from 'crono-fe-common/icons/Forager.png';
import Cognism from 'crono-fe-common/icons/Cognism.png';
import Lusha from 'crono-fe-common/icons/Lusha.png';
import ZoomInfo from 'crono-fe-common/icons/ZoomInfo.png';

export type EnrichmentProviderKey =
  | 'hunter'
  | 'datagma'
  | 'prospeo'
  | 'contactout'
  | 'apollo'
  | 'rocketreach'
  | 'cleon1'
  | 'findymail'
  | 'icypeas'
  | 'forager'
  | ExternalProviderType;

export interface IEnrichmentProvider {
  id: number;
  icon: string;
  key: EnrichmentProviderKey;
  name: string;
  dataProvided: Array<
    'email' | 'phone' | 'contact linkedIn url' | 'company linkedIn url'
  >;
  external?: boolean;
  editable?: boolean;
  authType?: EnrichmentAuthType;
}

export interface LocalEnrichmentProvider extends Omit<
  IEnrichmentProvider,
  'id'
> {
  id: number | undefined | null;
  enabled: boolean;
  apiKey?: string;
  externalProviderError?: ExternalProviderError;
  beforeCronoProviders?: boolean;
  displayOrder?: number;
  isConnected?: boolean;
  clientSecretEnding?: string;
  secretEnding?: string;
  clientId?: string;
  clientSecret?: string;
}

export const enrichmentProviderDataProvided: Record<
  IEnrichmentProvider['dataProvided'][number],
  string
> = {
  email: 'Email',
  phone: 'Phone',
  'contact linkedIn url': 'LinkedIn URL',
  'company linkedIn url': 'LinkedIn URL',
};

export const enrichmentProviders: IEnrichmentProvider[] = [
  {
    id: 1,
    icon: Hunter,
    key: 'hunter',
    name: 'Hunter',
    dataProvided: ['email', 'contact linkedIn url', 'company linkedIn url'],
  },
  {
    id: 2,
    icon: Prospeo,
    key: 'prospeo',
    name: 'Prospeo',
    dataProvided: ['email', 'phone'],
  },
  {
    id: 3,
    icon: Apollo,
    key: 'apollo',
    name: 'Apollo',
    dataProvided: ['email', 'contact linkedIn url', 'company linkedIn url'],
  },
  {
    id: 4,
    icon: Datagma,
    key: 'datagma',
    name: 'Datagma',
    dataProvided: [
      'email',
      'phone',
      'contact linkedIn url',
      'company linkedIn url',
    ],
  },
  {
    id: 5,
    icon: RocketReach,
    key: 'rocketreach',
    name: 'RocketReach',
    dataProvided: ['email'],
  },
  {
    id: 6,
    icon: Findymail,
    key: 'findymail',
    name: 'FindyMail',
    dataProvided: ['email'],
  },
  {
    id: 7,
    icon: ContactOut,
    key: 'contactout',
    name: 'ContactOut',
    dataProvided: ['phone', 'contact linkedIn url', 'company linkedIn url'],
  },
  {
    id: 8,
    icon: Cleon1,
    key: 'cleon1',
    name: 'Cleon1',
    dataProvided: ['phone'],
  },
  {
    id: 10,
    icon: IcyPeas,
    key: 'icypeas',
    name: 'IcyPeas',
    dataProvided: ['email', 'contact linkedIn url', 'company linkedIn url'],
  },
  {
    id: 11,
    icon: Forager,
    key: 'forager',
    name: 'Forager',
    dataProvided: ['email', 'phone'],
  },
  {
    id: 12,
    icon: Cognism,
    key: ExternalProviderType.Cognism,
    name: 'Cognism',
    dataProvided: [
      'email',
      'phone',
      'contact linkedIn url',
      'company linkedIn url',
    ],
    external: true,
    editable: true,
    authType: EnrichmentAuthType.ApiKey,
  },
  {
    id: 13,
    icon: Lusha,
    key: ExternalProviderType.Lusha,
    name: 'Lusha',
    dataProvided: [
      'email',
      'phone',
      'contact linkedIn url',
      'company linkedIn url',
    ],
    external: true,
    editable: true,
    authType: EnrichmentAuthType.ApiKey,
  },
  {
    id: 14,
    icon: ZoomInfo,
    key: ExternalProviderType.ZoomInfo,
    name: 'ZoomInfo',
    dataProvided: [
      'email',
      'phone',
      'contact linkedIn url',
      'company linkedIn url',
    ],
    external: true,
    editable: true,
    authType: EnrichmentAuthType.App,
  },
  {
    id: 15,
    icon: Apollo,
    key: ExternalProviderType.Apollo,
    name: 'Apollo',
    dataProvided: [
      'email',
      'phone',
      'contact linkedIn url',
      'company linkedIn url',
    ],
    external: true,
    editable: true,
    authType: EnrichmentAuthType.ApiKey,
  },
];

export const providerErrorMessages: Record<ExternalProviderError, string> = {
  [ExternalProviderError.InvalidApiKey]: 'API Key Connection Failed',
  [ExternalProviderError.InvalidAccessToken]: 'Access Token Connection Failed',
};
